import React from 'react';
import PropTypes from 'prop-types';
import useQuery from 'hooks/apollo/useQuery';
import { RESIDUAL_VALUE_GRID_DETAILS_ITEMS } from 'features/residualValueGrid/queries';
import { NavPillsBoxContainer } from 'components/common/Styles';
import { NavPills } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import ResidualValueGridDetailsComponent from './ResidualValueGridDetailsComponent';
import ResidualValueGridItemsComponent from './ResidualValueGridItemsComponent';
import WrappedFakeText from 'components/common/WrappedFakeText';
import { Box } from '@mui/material';

const ResidualValueGridSplitItemDetailsComponent = ({ id, lens, resetLens, validation, disabled }) => {
  const { t } = useTranslation();

  const { loading } = useQuery(RESIDUAL_VALUE_GRID_DETAILS_ITEMS, {
    variables: { id },
    skip: !id,
    onCompleted: data => {
      resetLens({
        details: data?.residualValueGridDetails?.details || [],
        items: data?.residualValueGridItems?.items?.map(x => ({ id: x.itemId, name: x.itemName })) || []
      });
    }
  });

  return (
    <NavPillsBoxContainer>
      {loading && <WrappedFakeText />}
      {!loading && (
        <NavPills
          fullWidth
          tabs={[
            {
              label: t('ResidualValueGrid.DepreciationGrid'),
              content: (
                <Box mt={1}>
                  <ResidualValueGridDetailsComponent lens={lens.details} validation={validation.details} disabled={disabled} />
                </Box>
              )
            },
            {
              label: t('ResidualValueGrid.Items'),
              content: (
                <Box mt={1}>
                  <ResidualValueGridItemsComponent lens={lens.items} disabled={disabled} />
                </Box>
              )
            }
          ]}
        />
      )}
    </NavPillsBoxContainer>
  );
};

ResidualValueGridSplitItemDetailsComponent.propTypes = {
  id: PropTypes.number,
  lens: PropTypes.object,
  resetLens: PropTypes.func,
  validation: PropTypes.object,
  disabled: PropTypes.bool
};

export default ResidualValueGridSplitItemDetailsComponent;
